// @flow
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type Props = {
  displayable: Object,
  history: Object,
  t: Object,
};

class SwitchFooter extends React.Component<Props> {
  render() {
    const { displayable, t, history } = this.props;
    const { pathname } = history.location;
    return (
      <div
        style={{
          display: 'flex',
          padding: 20,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Typography color="textPrimary" align="right">
          {!pathname.includes('/web/scribe-dashboard') && displayable.scribeDashboard && (
            <>
              <span>{t('switchFooter.enterScribe')} </span>
              <Link to="/web/scribe-dashboard">
                <button className="a-button" type="submit">
                  {t('switchFooter.dashboard')}.
                </button>
              </Link>
            </>
          )}
          {pathname.includes('/web/scribe-dashboard') && (
            <>
              <span> {t('switchFooter.join')} </span>
              <Link to="/web/conversations">
                <button className="a-button" type="submit">
                  {t('switchFooter.conversations')}
                </button>
              </Link>
              <span>. </span>
            </>
          )}
        </Typography>
        <div style={{ flexGrow: 1 }} />
      </div>
    );
  }
}

export default withTranslation()(SwitchFooter);
